import React, { Component, Fragment } from 'react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode, ConstrainMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { MessageBars } from '../Outils/MessageBars';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Toggle } from 'office-ui-fabric-react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { FicheCompte } from '../Fiche/FicheCompte';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import '../../css/immocom.css';

/*
**********************************************************************************
 PROPS:
    ATTRIBUTS :
        bool    activerFiltres  détermine l'affichage ou non du bouton filtres
        bool    activerActions  détermine l'affichage ou non des boutons d'actions
        int     idSociete       permet l'affichage des compte d'une société en particulier
    METHODES :
**********************************************************************************
*/

export class DetailsListCompte extends Component {

    _creationContent = () => {
        const { items } = this.state;

        return (
            <DetailsList
                items={items}
                columns={this.columns}
                selectionMode={SelectionMode.single}
                selection={this._selection}
                constrainMode={ConstrainMode.unconstrained}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                onRenderItemColumn={this._onRenderItemColumn}
            />
        );
    }

    constructor(props) {

        super(props);

        this._objetState = {
            items: [],
            loginCompte: '',

            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            onAffichePanelCompte: false,
            onAffichePanelFiltre: false,

            //onPeutChargerLeComposantFicheCompte: false,

            pageIndex: 1,
            facteurNbreEnregistrement: 500,
            tri: "",

            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: '',
            messageMessageBarFiltres: '',

            filtreIdSociete: this.props.idSociete || 0,
            filtreActif: true,

            //nombreMinSlider: 100,
            //nombreMaxSlider: 10000,
            //stepSlider: 100
        };

        this.state = this._objetState;

        //#region chargement des columns
        let columnsTemp = [];
        columnsTemp.push({
            key: 'actif',
            name: 'Actif',
            fieldName: 'actif',
            minWidth: 30,
            maxWidth: 30,
            isResizable: true,
            onRender: (item) => {
                let actif = item.actif;
                return <span title={actif}>{actif}</span>;
            }
        });
        columnsTemp.push({
            key: 'loginCompte',
            name: 'Login',
            fieldName: 'loginCompte',
            minWidth: 100,
            maxWidth: 230,
            isResizable: true,
            onRender: (item) => {
                const loginCompte = item.loginCompte;
                return <span title={loginCompte}>{loginCompte}</span>;
            }
        });
        columnsTemp.push({
            key: 'nom',
            name: 'Nom',
            fieldName: 'nom',
            minWidth: 80,
            maxWidth: 230,
            isResizable: true,
            onRender: (item) => {
                let nom = item.nom;
                return <span title={nom}>{nom}</span>;
            }
        });
        columnsTemp.push({
            key: 'prenom',
            name: 'Prenom',
            fieldName: 'prenom',
            minWidth: 100,
            maxWidth: 230,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prenom = item.prenom;
                return <span title={prenom}>{prenom}</span>;
            }
        });
        columnsTemp.push({
            key: 'tel',
            name: 'Téléphone',
            fieldName: 'tel',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let tel = item.tel;
                return <span title={tel}>{tel}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomSociete',
            name: 'Société',
            fieldName: 'nomSociete',
            minWidth: 80,
            maxWidth: 220,
            isResizable: true,
            onRender: (item) => {
                let nomSociete = item.nomSociete;
                return <span title={nomSociete}>{nomSociete}</span>;
            }
        });
        columnsTemp.push({
            key: 'agence',
            name: 'Agence',
            fieldName: 'agence',
            minWidth: 100,
            maxWidth: 220,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let agence = item.agence;
                return <span title={agence}>{agence}</span>;
            }
        });
        columnsTemp.push({
            key: 'region',
            name: 'Région',
            fieldName: 'region',
            minWidth: 100,
            maxWidth: 220,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let region = item.region;
                return <span title={region}>{region}</span>;
            }
        });
        columnsTemp.push({
            key: 'edition',
            name: 'Edition',
            ariaLabel: 'Modifier le compte',
            fieldName: 'edition',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Edit' }}
                    title="Modifier le compte"
                    ariaLabel="Edition"
                    onClick={this._onAffichagePanelCompte(item.loginCompte)} />;
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }

    static defaultProps = {
        activerActions: true,
        activerFiltres: true
    }

    _getItems = () => {
        let items = [
            {
                key: 'search',
                onRender: () => <SearchBox placeholder="Recherche rapide" className="searchBox"
                    onSearch={value => this._onSearchBox(value)}
                    onClear={(e) => this._onSearchBox('')}
                //onBlur={(e) => this._onBlurSearchBox(e.target.value)}
                />
            }
        ];
        if (this.props.activerActions)
            items.push(
                {
                    key: 'nouveauProfilUtilisateur',
                    name: 'Nouveau profil utilisateur',
                    iconProps: {
                        iconName: 'Add'
                    },
                    onClick: this._onAffichagePanelCompte(null)
                }
            )
        return items;
    }

    _getFarItems = () => {
        let farItems = [
            {
                key: 'nombreEnregistrement',
                name: this.state.items.length
            }
        ];
        if (this.props.activerFiltres)
            farItems.push(
                {
                    key: 'filtre',
                    name: 'Filtres',
                    iconProps: { iconName: 'Filter' },
                    iconOnly: true,
                    disabled: this.state.disableFiltres,
                    onClick: this._onAffichePanelFiltre
                }
            );
        return farItems;
    }

    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des comptes en cours'
            });

            let objet = {
                "nbreEnreg": this.state.facteurNbreEnregistrement,
                "recherche": this.state.recherche,
                "tri": this.state.tri,
                "filtreIdSociete": this.state.filtreIdSociete,
                "filtreActif": this.state.filtreActif,
                "pageIndex": this.state.pageIndex
            };

            var url = 'api/Liste/ListeDesPROFILSUTILISATEUR';
            var paramPost = Scriba.fetch().createParameterPost(objet);

            fetch(url, paramPost)
                .then(response => response.json())
                .then(responseFetch => {
                    let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        //YD : 17/06/2020 : Ajout test sur listeItem != null
                        let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);
                        let new_Items = [];

                        if (this.state.pageIndex === 1) {
                            new_Items = listeItem;
                        }
                        else {
                            new_Items = this.state.items;
                            new_Items = new_Items.concat(listeItem);
                        }

                        this.setState({
                            items: new_Items,

                            enCoursDeTraitement: false,
                            messageEnCoursTraitement: '',
                            hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                            warningMessage: retourVerif.warningMessage,
                            hideMessageBarError: retourVerif.hideMessageBarError,
                            errorMessage: retourVerif.errorMessage,
                            hideMessageBarFiltres: (this.state.filtreActif || this.state.filtreIdSociete),
                            messageMessageBarFiltres: 'Filtres activés : ' + (this.state.filtreActif ? '"Actif : Oui"' : '"Actif : Non"') + (this.state.filtreIdSociete ? ', "Société"' : '')
                        });
                    }
                    else {
                        let stateTemp = {};
                        stateTemp.items = [];

                        Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true, onAffichePanelCompte: false });
    };

    _onAffichagePanelCompte = (loginCompte) => () => {
        this.setState({
            onAffichePanelCompte: true,
            //onPeutChargerLeComposantFicheCompte: true,
            loginCompte: loginCompte
        });
    }

    _onCachePanelCompteEtRechargementDesDonnees = () => {
        this.setState({
            onAffichePanelCompte: false,
            loginCompte: ''
        });
        this._chargementDonnees();
    };

    _onCachePanelCompte = () => {
        this.setState({
            onAffichePanelCompte: false,
            //onPeutChargerLeComposantFicheCompte: false,
            loginCompte: ''
        });
    };

    _onCachePanelFiltre = () => {
        this.setState({
            onAffichePanelFiltre: false
        });
    };

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreIdSociete: 0,
            filtreActif: true,
        });
    }

    _onColumnHeaderClick = (ev, column) => {
        let key = column.key;
        let onTrie = (key !== 'edition')
        if (onTrie) {
            const columns = this.columns;
            const newColumns = columns.slice();
            const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

            newColumns.forEach((newCol) => {
                if (newCol === currColumn) {
                    currColumn.isSortedDescending = !currColumn.isSortedDescending;
                    currColumn.isSorted = true;
                } else {
                    newCol.isSorted = false;
                    newCol.isSortedDescending = false;
                }
            });

            let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

            this.setState(
                { tri, pageIndex: 1 },
                this._chargementDonnees
            );
        }
    };

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    //_modificationNbreEnregistrementParPageETrepositionnementDuScrollEnHautDeLaPage(value) {
    //    this.setState({ facteurNbreEnregistrement: value, pageIndex: 1 });
    //}

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onRenderDetailsHeader = (props, defaultRender) => {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    };

    _onChangeSociete = (value) => {
        this.setState({
            filtreIdSociete: value
        });
    }

    componentDidMount = () => {
        this._chargementDonnees();
    }

    // KP - 02/01/2023 : inutile, le périmètre n'influence pas le résultat
    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //}

    componentWillUnmount = () => {
        //document.removeEventListener('scroll', this._evenementScroll);
    }

    render = () => {

        //<Slider
        //    label="Nombre d'enregistrements/page"
        //    min={this.state.nombreMinSlider}
        //    max={this.state.nombreMaxSlider}
        //    step={this.state.stepSlider}
        //    defaultValue={this.state.facteurNbreEnregistrement}
        //    showValue={true}
        //    //valueFormat={(value) => (value === 2015 ? 'Toutes' : value)}
        //    onChange={(value) => this._modificationNbreEnregistrementParPageETrepositionnementDuScrollEnHautDeLaPage(value)}
        ///>

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            {this.props.activerFiltres &&
                <Panel
                    isOpen={this.state.onAffichePanelFiltre}
                    type={PanelType.smallFixedFar}
                    onDismiss={this._onCachePanelFiltre}
                    headerText="Filtres"
                    closeButtonAriaLabel="Close"
                    onRenderFooterContent={this._onRenderFooterFiltresContent}
                >
                    <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                            <div className="buttonFiltres">
                                <IconButton
                                    iconProps={{ iconName: 'ClearFilter' }}
                                    className="buttonFiltres"
                                    title="Réinitialiser les filtres"
                                    ariaLabel="Filtres"
                                    onClick={this._reinitFiltre}
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12">
                                <ComboBoxSociete
                                    onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                                    selectedKey={this.state.filtreIdSociete}
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12">
                                <Toggle
                                    label="Actif"
                                    onText="Oui"
                                    offText="Non"
                                    checked={this.state.filtreActif}
                                    onChange={(e, isChecked) => this.setState({ filtreActif: isChecked })}
                                />
                            </div>
                        </div>
                    </div>
                </Panel>
            }

            <FicheCompte
                onAffichePanelCompte={this.state.onAffichePanelCompte}
                loginCompte={this.state.loginCompte}
                onAnnuleFiche={() => this._onCachePanelCompte()}
                onEnregistrementFiche={() => this._onCachePanelCompteEtRechargementDesDonnees()}
            />

        </Fragment>;
    }
}